




























































































import { Vue, Component, Inject } from "vue-property-decorator";

// Types
import {
  ISupportDepartmentsProvider,
  ISupportDepartmentsProviderMethods
} from "@/models/providers/supportDepartments";

@Component({
  components: {
    "support-department-row-item": () =>
      import(
        "@/components/app/admin/settings/supportDepartments/supportDepartmentRowItem.vue"
      )
  }
})
export default class SupportDepartmentsItems extends Vue {
  // Inject - Support departments list provider data

  @Inject({ from: "supportDepartmentsProvider" })
  public $supportDepartmentsData!: () => ISupportDepartmentsProvider;

  public get supportDepartmentsData() {
    return this.$supportDepartmentsData();
  }

  @Inject({ from: "supportDepartmentsProviderMethods" })
  public $supportDepartmentsMethods!: ISupportDepartmentsProviderMethods;

  // Computed

  public get skeletonSize() {
    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return (
      !this.supportDepartmentsData.isLoading &&
      !this.supportDepartmentsData.total
    );
  }

  public get showSkeletons() {
    return (
      this.supportDepartmentsData.isLoading ||
      !this.supportDepartmentsData.total
    );
  }
}
